export const url =
  process.env.NODE_ENV !== 'production'
    ? process.env.REACT_APP_DEV_API_URL ?? ''
    : '';
export const base = 'api';
export const baseUrl = `${url}/${base}/`;
